module.exports = __webpack_public_path__ + "assets/img/flecha-izquierda.d39b45c5.svg";